/* HADELE product page behaviour: variant matching and the image carousel.
   Self-contained — it does not rely on the stock product section. */
(function () {
  'use strict';

  function init(root) {
    if (!root || root.dataset.hdpReady) return;
    root.dataset.hdpReady = '1';

    var dataEl = root.querySelector('[data-hdp-variants]');
    var variants = [];
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { variants = []; }

    var form = root.querySelector('[data-hdp-form]');
    var idInput = root.querySelector('[data-hdp-id]');
    var addBtn = root.querySelector('[data-hdp-add]');
    var priceOut = root.querySelector('[data-hdp-price]');
    var inputs = Array.prototype.slice.call(root.querySelectorAll('[data-hdp-opt]'));

    function money(cents) {
      var s = (cents / 100).toFixed(2);
      var cur = window.Shopify && window.Shopify.currency && window.Shopify.currency.active;
      return cur === 'AUD' ? '$' + s + ' AUD' : '$' + s;
    }

    function chosen() {
      var out = [];
      inputs.forEach(function (i) {
        if (i.checked) out[parseInt(i.dataset.hdpOpt, 10)] = i.value;
      });
      return out;
    }

    function match(sel) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        var ok = true;
        for (var k = 0; k < sel.length; k++) {
          if (sel[k] !== undefined && v.options[k] !== sel[k]) { ok = false; break; }
        }
        if (ok) return v;
      }
      return null;
    }

    function refreshAvailability() {
      var sel = chosen();
      inputs.forEach(function (i) {
        var idx = parseInt(i.dataset.hdpOpt, 10);
        var probe = sel.slice();
        probe[idx] = i.value;
        var v = match(probe);
        i.disabled = !(v && v.available);
      });
    }

    function update() {
      var v = match(chosen());

      inputs.forEach(function (i) {
        if (!i.checked) return;
        var out = root.querySelector('[data-hdp-outfor="' + i.dataset.hdpOpt + '"]');
        if (out) out.textContent = i.value;
      });

      if (!v) {
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = 'Unavailable'; }
        return;
      }

      if (idInput) idInput.value = v.id;

      if (priceOut) {
        priceOut.innerHTML = (v.compare_at_price && v.compare_at_price > v.price)
          ? '<del>' + money(v.compare_at_price) + '</del><ins>' + money(v.price) + '</ins>'
          : money(v.price);
      }

      if (addBtn) {
        addBtn.disabled = !v.available;
        addBtn.textContent = v.available ? (addBtn.dataset.hdpLabel || 'Add to cart') : 'Sold out';
      }

      if (window.history && history.replaceState && v.id) {
        try {
          var u = new URL(window.location.href);
          u.searchParams.set('variant', v.id);
          history.replaceState({}, '', u.toString());
        } catch (e) {}
      }

      document.dispatchEvent(new CustomEvent('hdp:variant', { detail: { variant: v } }));
    }

    inputs.forEach(function (i) {
      i.addEventListener('change', function () { refreshAvailability(); update(); });
    });

    refreshAvailability();
    update();

    if (form && addBtn) {
      form.addEventListener('submit', function () { addBtn.textContent = 'Adding'; });
    }

    /* Carousel. Desktop shows two frames at once and mobile one, so nothing
       here assumes a page is a single slide: the step is measured from the
       slides themselves and how many fit decides what counts as a page. */
    var strip = root.querySelector('[data-hdp-strip]');
    if (strip) {
      var slides = Array.prototype.slice.call(strip.children);
      var dots = root.querySelector('[data-hdp-count]');
      var marks = dots ? Array.prototype.slice.call(dots.children) : [];
      var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-hdp-thumb]'));
      var prev = root.querySelector('[data-hdp-prev]');
      var next = root.querySelector('[data-hdp-next]');

      function step() {
        if (slides.length > 1) {
          var d = slides[1].getBoundingClientRect().left - slides[0].getBoundingClientRect().left;
          if (d > 1) return d;
        }
        return strip.clientWidth || 1;
      }

      function per() {
        return Math.max(1, Math.round(strip.clientWidth / step()));
      }

      function lastStart() {
        return Math.max(0, slides.length - per());
      }

      function at() {
        return Math.max(0, Math.min(lastStart(), Math.round(strip.scrollLeft / step())));
      }

      /* The frames either side of the ones on screen are fetched ahead of
         time, so paging through the shoot never lands on an empty frame
         while a lazy image is still arriving. */
      function warm(n) {
        for (var i = n - 1; i <= n + per(); i++) {
          var s = slides[i];
          if (!s) continue;
          var img = s.querySelector('img');
          if (img && img.loading === 'lazy') img.loading = 'eager';
        }
      }

      function paint() {
        var n = at();
        var p = per();
        warm(n);
        var on = function (i) { return i >= n && i < n + p; };
        marks.forEach(function (m, i) { m.classList.toggle('is-on', on(i)); });
        thumbs.forEach(function (t, i) {
          t.classList.toggle('is-on', on(i));
          t.setAttribute('aria-current', on(i) ? 'true' : 'false');
        });
        if (prev) prev.disabled = n <= 0;
        if (next) next.disabled = n >= lastStart();
      }

      function go(n) {
        n = Math.max(0, Math.min(lastStart(), n));
        warm(n);
        var left = n * step();
        if (strip.scrollTo) strip.scrollTo({ left: left, behavior: 'smooth' });
        else strip.scrollLeft = left;
      }

      strip.addEventListener('scroll', function () {
        window.requestAnimationFrame(paint);
      }, { passive: true });

      if (prev) prev.addEventListener('click', function () { go(at() - per()); });
      if (next) next.addEventListener('click', function () { go(at() + per()); });
      thumbs.forEach(function (t, i) {
        t.addEventListener('click', function () { go(i); });
      });

      window.addEventListener('resize', function () {
        window.requestAnimationFrame(paint);
      });

      paint();
    }
  }

  function boot() {
    Array.prototype.slice.call(document.querySelectorAll('[data-hdp]')).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();